// Max number of days user can keep same password
export const MAX_PASSWORD_CHANGE_DAYS = 90;

// The number of days before 90 days when trigger password message will be shown to user
export const RemainingDays = [15, 10, 5, 3];

// The days from last password change user will get the message.
export const triggerDays = RemainingDays.map((days) => MAX_PASSWORD_CHANGE_DAYS - days);
